import { GRADEBOOK_SCOPE } from '../const';
import { REDUCER } from '../reducers/reducersConst';

/**
 * GRADEBOOK REDUCER
 */
let defaultgradeBookState = {
  books: [],
  units: [],
  lessons: [],
  activities: [],
  tasks: [],
  gradebookScope: GRADEBOOK_SCOPE.ACTIVITIES,
  selectedBook: null,
  selectedLesson: null,
  selectedUnit: null,
  grades: null
};

export let gradebook = (state = defaultgradeBookState, action) => {
  switch (action.type) {
    case REDUCER.GRADEBOOK.SET_GRADES:
      return {
        ...state,
        grades: action.grades
      };
    case REDUCER.GRADEBOOK.SET_BOOKS_DATA:
      return {
        ...state,
        books: JSON.parse(JSON.stringify(action.books))
      };
    case REDUCER.GRADEBOOK.SET_GRADEBOOK_SCOPE:
      return {
        ...state,
        gradebookScope: action.gradebookScope
      };
    case REDUCER.GRADEBOOK.SET_UNITS_DATA:
      return {
        ...state,
        units: JSON.parse(JSON.stringify(action.units))
      };
    case REDUCER.GRADEBOOK.SET_LESSONS_DATA:
      return {
        ...state,
        lessons: JSON.parse(JSON.stringify(action.lessons))
      };
    case REDUCER.GRADEBOOK.SET_ACTIVITIES_DATA:
      return {
        ...state,
        activities: JSON.parse(JSON.stringify(action.activities))
      };
    case REDUCER.GRADEBOOK.SET_TASKS_DATA:
      return {
        ...state,
        tasks: JSON.parse(JSON.stringify(action.tasks))
      };
    case REDUCER.GRADEBOOK.SET_TASKS_FILTER_PARAMS:
      return {
        ...state,
        tasksFilterParams: action.tasksFilterParams
      };
    case REDUCER.GRADEBOOK.SET_SELECTED_BOOK:
      return {
        ...state,
        selectedBook: action.selectedBook,
        gradebookScope: GRADEBOOK_SCOPE.ACTIVITIES
      };
    case REDUCER.GRADEBOOK.SET_SELECTED_UNIT:
      return {
        ...state,
        selectedUnit: action.selectedUnit,
        gradebookScope: GRADEBOOK_SCOPE.ACTIVITIES
      };
    case REDUCER.GRADEBOOK.SET_SELECTED_LESSON:
      return {
        ...state,
        selectedLesson: action.selectedLesson,
        gradebookScope: GRADEBOOK_SCOPE.ACTIVITIES
      };
    default:
      return state;
  }
};
